import { StreamActions } from '@hotwired/turbo';
import { Turbo } from "@hotwired/turbo-rails";
import { Modal } from 'flowbite';

const closeOverlay = id => {
    try {
        const instance = new Modal(document.getElementById(id));
        if (instance) instance.hide();
    }
    catch (e) {
        console.error(`Error closing modal for ID=${id}`, e);
    }
}

StreamActions.close_modals = function() {
    const modalId = this.getAttribute('id');
    if (!!modalId?.length) closeOverlay(modalId);
    else {
        const modals = document.querySelectorAll('.modal');
        modals.forEach(modal => closeOverlay(modal.id));
    }
}

StreamActions.redirect_to = function() {
    const path = this.getAttribute('path');
    if (!!path?.length) Turbo.visit(path);
}